/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import _ from 'underscore';
import store from '../state/store';

store.on('enquiry:customers:show', function(enquiry_id, customer_id) {
  const params =
    {enquiry_id};

  return $.ajax({
    url: `/api/sales/customers/${customer_id}`,
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    data: params,
    success: (data) => {
      return store.get().enquiry.set({customer: data});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:customers:update', function(enquiry_id, customer_id, update_params) {
  if (update_params == null) { update_params = {}; }
  const request_params = _.extend(update_params, {
    enquiry_id,
    customer_id
  }
  );

  return $.ajax({
    url: `/api/sales/customers/${customer_id}`,
    type: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(request_params),
    success: (data) => {
      return store.get().enquiry.set({customer: data});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}